import Form from "./components/Form";
import 'bootstrap/dist/css/bootstrap.min.css';
import {Route, BrowserRouter as Router, Switch} from 'react-router-dom'
import Receipt from "./components/Receipt";
import Approval from "./components/Approval";
import Test from "./components/Test";
import Home from "./components/Home";


function App() {
  function notFound(){
    return(
        <div>
            404 not found
        </div>
    )
}
  return (
    <div className="app">
      <Router>
                <Switch>
                <Route path="/" exact component={Home}/>
                <Route path="/appointment" exact component={Form}/>
                <Route path="/test" exact component={Test}/>
                <Route path="/approval/:code" exact component={Approval}/>
                <Route exact path="/receipt/:code" component={Receipt} />
                <Route component={notFound} />
                </Switch>
            </Router>
    </div>
  );
}

export default App;
